var _line, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressBarStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 48,
    viewBox: "0 0 16 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 48,
    x2: 8,
    y2: 16,
    stroke: "#EC812D",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EC812D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65625 3L6.61585 6.46317L4 7.68048L6.70258 8.71131L7.31452 12L9.14928 9.27878L12 9.9515L10.4152 6.9208L11.8201 4.51935L9.23978 5.37342L6.65625 3Z",
    fill: "#FFFCF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarStep);
export default __webpack_public_path__ + "static/media/progress-bar-step.9382db5255d7db558a15a65551f18b03.svg";
export { ForwardRef as ReactComponent };